export default __webpack_public_path__ + "static/media/blue.02152214.png";